import { useState, useEffect, useContext, useCallback } from "react";
import { Box, Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@material-ui/core";
import { ConfirmDialogTS } from "../../_AAA/components/ReactDialogTS";
import { ConfirmDialogPropsScroll, ConfirmDialogPropsSize } from "../../js/types";
import { MainPageDialogContext } from "../../js/MainPageDialogContext";
import { ResultObj } from "../../js/Domain";
import { useUserApi, UserSearchResItem } from "../../js/adapter/UserAdapter";
import { useUserControlApi } from "../../js/adapter/UsercontrolAdapter";

type RouterMenuModalSimulateUserProps = {
    modalClose: () => void;
};

type SimulateUserSearchParams = {
    username: string;
    name: string;
};

const tableHead = [
    { name: "排序" },
    { name: "ID" },
    { name: "使用者帳號" },
    { name: "使用者姓名" },
    { name: "職務" },
    { name: "狀態" },
];

const RouterMenuModalSimulateUser = ({ modalClose }: RouterMenuModalSimulateUserProps) => {
    const { responseMessage } = useContext(MainPageDialogContext);
    const userApiManager = useUserApi();
    const userControlApiManager = useUserControlApi();

    const [pageSearch, setPageSearch] = useState<SimulateUserSearchParams>({ username: "", name: "" });
    const [resUArr, setResUArr] = useState<UserSearchResItem[]>([]);

    useEffect(() => {
        const init = async () => {
            if (!userApiManager) return;
            try {
                const resU = await userApiManager.UserSearch({ page: 0, num_per_page: 10 });
                setResUArr(resU.data || []);
            } catch (error) {
                responseMessage(error as ResultObj);
            }
        };
        init();
    }, [userApiManager]);

    const searchHandleInput = useCallback(async (e: React.ChangeEvent<HTMLInputElement>) => {
        const name = e.target.name.split("--")[1] as keyof SimulateUserSearchParams;
        const value = e.target.value;
        const newSearch = { ...pageSearch, [name]: value };
        setPageSearch(newSearch);
        if (!userApiManager) return;
        try {
            const res = await userApiManager.UserSearch({ ...newSearch, page: 0, num_per_page: 10 });
            setResUArr(res.data || []);
        } catch (error) {
            responseMessage(error as ResultObj);
        }
    }, [pageSearch, userApiManager, responseMessage]);

    const handleTableRow = useCallback(async (elem: UserSearchResItem) => {
        if (!userControlApiManager) return;
        try {
            const resD = await userControlApiManager.UserSimulate({ user_id: elem.user_id });
            const simulate_token = resD.data;
            const new_window = window.open(window.location.origin + "/Index/Home", "ESD", "height=700,width=1000");
            if (new_window) {
                new_window.sessionStorage.removeItem("items");
                new_window.sessionStorage.setItem("home_page", elem.home_page_name);
                new_window.sessionStorage.setItem("token", simulate_token);
                new_window.sessionStorage.setItem("user_simulate", "Y");
                new_window.sessionStorage.setItem("user_id", elem.user_id);
                new_window.sessionStorage.setItem("login_account", elem.username);
                new_window.sessionStorage.setItem("name", elem.name);
            }
        } catch (error) {
            responseMessage(error as ResultObj);
        }
    }, [userControlApiManager, responseMessage]);

    return (
        <ConfirmDialogTS
            modalOpen={true}
            closeClick={modalClose}
            modal={{
                id: "simulateUserModal",
                modaltitle: "選擇帳號",
                size: ConfirmDialogPropsSize.MD,
                scroll: ConfirmDialogPropsScroll.BODY,
                messages: (
                    <>
                        <Box display="flex" flexWrap="wrap" alignContent="flex-start" style={{ marginBottom: "2rem" }}>
                            <Grid item lg={6} md={6} xs={12}>
                                <div style={{ margin: "0rem 1rem", maxHeight: "150px" }}>
                                    <TextField
                                        id="search--username"
                                        name="search--username"
                                        size="small"
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        label="使用者帳號"
                                        placeholder="請輸入"
                                        type="text"
                                        style={{ margin: "0.5rem 0" }}
                                        onChange={searchHandleInput}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </div>
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <div style={{ margin: "0rem 1rem", maxHeight: "150px" }}>
                                    <TextField
                                        id="search--name"
                                        name="search--name"
                                        size="small"
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        label="使用者名稱"
                                        placeholder="請輸入完整使用者名稱"
                                        type="text"
                                        style={{ margin: "0.5rem 0" }}
                                        onChange={searchHandleInput}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </div>
                            </Grid>
                        </Box>
                        <TableContainer style={{ boxShadow: "none" }}>
                            <Table style={{ minWidth: 650 }}>
                                <TableHead>
                                    <TableRow>
                                        {tableHead.map((item, index) => (
                                            <TableCell key={index}>{item.name}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {resUArr.length > 0 ? (
                                        resUArr.map((elem, index) => (
                                            <TableRow
                                                key={index}
                                                onClick={() => handleTableRow(elem)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{elem.user_id}</TableCell>
                                                <TableCell>{elem.username}</TableCell>
                                                <TableCell>{elem.name}</TableCell>
                                                <TableCell>{elem.ul_name}</TableCell>
                                                <TableCell>{elem.disable === "Y" ? "關閉" : "正常"}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow className="noHover">
                                            <TableCell colSpan={8} align="center">查無結果</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                ),
                modalBtnGroup: (
                    <div style={{ display: "flex", justifyContent: "start", width: "100%" }}>
                        <Button color="primary" type="button" onClick={modalClose}>
                            取消
                        </Button>
                    </div>
                ),
            }}
        />
    );
};

export default RouterMenuModalSimulateUser;
